var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: "详情",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, "label-width": "120px" }
        },
        _vm._l(_vm.form.extend, function(domain, index) {
          return _c(
            "div",
            { key: index + "k", staticStyle: { width: "100%" } },
            [
              _c(
                "div",
                { staticClass: "lodingItem-operationFrame  x-c" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      staticStyle: { "margin-right": "20px" },
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: false, placeholder: "请输入" },
                        model: {
                          value: domain.label,
                          callback: function($$v) {
                            _vm.$set(domain, "label", $$v)
                          },
                          expression: "domain.label"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        "label-width": "0",
                        prop: "params." + index + ".value"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: false, placeholder: "请输入" },
                        model: {
                          value: domain.value,
                          callback: function($$v) {
                            _vm.$set(domain, "value", $$v)
                          },
                          expression: "domain.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }